import dayjs from 'dayjs'
// import Store from '@/store/modules/indexStore'
const mixin = {

  filters: {
    provess (value) {
      switch (value) {
        case 'NSSW':
          return '靠窗座位'
        case 'NSSA':
          return '靠走道座位'
        case 'NSST':
          return '普通座位'
        default:
          return '无'
      }
    },
    hobbyFood (value) {
      let obj = {
        BBML: '婴儿餐',
        AVML: '亚洲素餐',
        BLML: '清淡餐食',
        CHML: '儿童餐',
        DBML: '糖尿病患者餐',
        FPML: '水果拼盘',
        GFML: '无麦麸餐',
        HNML: '印度餐食',
        KSML: '犹太教餐',
        LCML: '低卡卢里餐食',
        LFML: '低脂肪/胆固醇餐',
        LSML: '低盐餐食',
        MOML: '穆斯林餐食',
        NLML: '无乳糖餐',
        RVML: '原质餐（稍加烹饪素餐）',
        SFML: '海鲜餐',
        VGML: '素食',
        VLML: '奶素食'
      }
      if (obj[value]) {
        return obj[value]
      } else {
        return '无'
      }
    },
    sortFilght (value) {
      let arr = ['按价格排序', '按起飞时间排序']
      return arr[value]
    },

    userNation (value) {
      let obj = {
        CN: '默认发送中文邮件及短信',
        EN: '默认发送英文邮件及短信'
      }
      return obj[value]
    },

    changeCartType (value) {
      let obj = {
        NI: '身份证',
        PP: '护照',
        TB: '台胞证',
        HX: '回乡证',
        GA: '港澳通行证',
        OS: '其它证件'
      }

      return obj[value]
    },

    changeArr (str) {
      return str.split(',')
    },
    dataForamtter (data) {
      return dayjs(data).format('YYYY-MM-DD')
    },
    dataForData (data) {
      return dayjs(data).valueOf()
    }

  }
}

export default mixin



// WEBPACK FOOTER //
// ./src/mixin/mixin.js